import { toast } from "react-toastify";
import { api } from "../Configurations/axios";


const DeletePleaPremisesFile = async ( companyId: string ,fileName: string, id: string, pleaId: string) => {
    try {
        const data = {companyId, id: id, fileName: fileName, pleaId: pleaId };
        const result = await api.delete("/PleaPremises/DeletePleaPremisesFile", { data });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const  DownloadPleaPremisesFile = async(
    Id: String ) =>{
      try{
          const result = await api.get(
            `/PleaPremises/DownloadPleaPremisesFile?id=${Id}`,{
              responseType: 'blob'
          });
          const response = result.data;
          return response;
      }catch(error: any) {
          throw new Error(error.response.data);
      }
};
const DownloadPleaPremisesFileModel = async() =>{
      try{
          const result = await api.get(
            `/PleaPremises/DownloadPleaPremisesFileModel`,{
              responseType: 'blob'
          });
          const response = result.data;
          return response;
      }catch(error: any) {
          throw new Error(error.response.data);
      }
};
  
const GetAllPleaPremisesByPleaId = async (pleaId: string) => {
    const result = await api.get(`/PleaPremises/GetAllFiles?pleaId=${pleaId}`);
    const response = await result.data;
    return response
}


const UploadPleaPremises = async (files: File[], url: string, userEmail: string, pleaId: string) => {
    try {
        var UploadFileDreAndBalanceCommand = new FormData();

        if (files && files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                UploadFileDreAndBalanceCommand.append('Files', files[i]);
            }
        } else {
            throw 'Por favor, insira pelo menos um arquivo';
        }        
        const result = await api.post(`/PleaPremises/PostPleaPremisesFile?Url=${url}&userEmail=${encodeURIComponent(userEmail)}&pleaId=${pleaId}`, UploadFileDreAndBalanceCommand, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        const response = await result.data;
        return response;
    } catch (error: any) {
        toast.error(error);
        throw new Error(error.response.data);
    }
}


export{
    DownloadPleaPremisesFile,
    DownloadPleaPremisesFileModel,
    DeletePleaPremisesFile,
    GetAllPleaPremisesByPleaId,
    UploadPleaPremises
}